import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { ECondition, EReward, TAchievement } from './interfaces';

export const convertToHours = (seconds: number): string =>
  (seconds / 60 / 60).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const getAchievementConditionText = (
  conditions: TAchievement['conditions'],
  currency: string,
  t: TTranslator<TLocalesKeys>
): string => {
  if (conditions.length > 1) {
    return t('achievement.condition.multiple');
  }

  const { name, value } = conditions[0];

  switch (name) {
    case ECondition.Register:
      return t('achievements.condition.register');
    case ECondition.ClubComment:
      return t('achievements.condition.clubComment');
    case ECondition.AddDepositOnce:
      return t('achievement.condition.addDepositOnce', value, currency);
    case ECondition.AddDepositOverall:
      return t('achievement.condition.addDepositOverall', value, currency);
    case ECondition.SpentHours:
      return t('achievement.condition.spentHours', convertToHours(value));
    case ECondition.OnlineBooking:
      return t('achievements.condition.onlineBooking.table', value);
    case ECondition.SpentSumOnce:
      return t('achievement.condition.spentSumOnce', value, currency);
    case ECondition.SpentSumOverall:
      return t('achievement.condition.spentSumOverall', value, currency);
  }
};

export const getAchievementRewardText = (
  { value, name }: TAchievement['rewards'][0],
  currency: string,
  t: TTranslator<TLocalesKeys>
): string => {
  switch (name) {
    case EReward.None:
      return t('achievements.reward.none');
    case EReward.AddDeposit:
      return t('achievements.reward.bonus', value, currency);
    case EReward.AddDiscount:
      return t('achievement.reward.discount', value);
  }
};
